module.exports = __webpack_public_path__ + "img/2_2.986d3dbe.jpg";